import React from 'react';
import { IACHDisbursementFormData } from 'types/order/escrow/achDisbursements/IACHDisbursementFormData';
import { ModalTarget } from '../../lineItem/ModalTarget.Constant';
import ReactDOM from 'react-dom';
import { ModalWindow } from 'ui-toolkit';
import { createWireFromACHSchema } from '../../../../escrow/disbursements/achPushDisbursements/createWireFromACH/createWireFromACHSchema';
import { Form, Formik } from 'formik';
import { useSelectCurrentOrder, useSelectCurrentOrderId } from 'selectors/order/selectCurrentOrder';
import { assertDefined } from 'utilities/Assertions';
import { convertACHToWireInitialValue } from './convertACHToWireInitialValue';
import { ConvertACHToWireForm } from './ConvertACHToWireForm';
import { useHasFeatureFlag } from '../../../../../../selectors/useHasFeatureFlag';

interface IConvertACHToWireModal {
  ach: IACHDisbursementFormData;
  onClose: () => void;
}

export const ConvertACHToWireModal: React.FC<IConvertACHToWireModal> = ({ ach, onClose }) => {
  const targetElement = document.getElementById(ModalTarget);

  const orderId = useSelectCurrentOrderId();
  assertDefined(orderId);
  const { data: order } = useSelectCurrentOrder();
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');


  return (
    <>
      <Formik
        initialValues={convertACHToWireInitialValue(ach, order, isSpruceWithZillowEnabled, isZillowClosingEnabled)}
        validationSchema={createWireFromACHSchema}
        onSubmit={() => { }}
        validateOnMount={true}
      >
        {({ isValid, values }) => (
          <Form>
            {targetElement &&
              ReactDOM.createPortal(
                <ModalWindow minHeight={500} onClose={onClose} title={'Create Wire From ACH'} uitype="fit" width={600}>
                  <ConvertACHToWireForm
                    ach={ach}
                    isValid={isValid}
                    orderId={orderId}
                    onClose={onClose}
                    values={values}
                  />
                </ModalWindow>,
                targetElement
              )}
            {!targetElement && (
              <ModalWindow minHeight={500} onClose={onClose} title={'Create Wire From ACH'} uitype="fit" width={600}>
                <ConvertACHToWireForm ach={ach} isValid={isValid} orderId={orderId} onClose={onClose} values={values} />
              </ModalWindow>
            )}
          </Form>
        )}
      </Formik>
    </>
  );
};
